import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { AppTransComponents } from 'app/appTrans';
import { MprcButton, MprcCardActions, MprcFormSubHeader } from "components";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { LmsPaths } from "routes/LmsRouter";
import { EditEnrollmentStepProps } from "views/lms/enrollment/Home";
import { useEnrollmentManagementContext } from "views/lms/enrollment/Home/EnrollmentManagementWrapper";

export const ResultBox: React.FC<EditEnrollmentStepProps> = (props) => {

    const ctx = useEnrollmentManagementContext();
    const { t } = useTranslation("lms");
    const training = ctx.training!;
    const classroom = ctx.classroom;
    const navigate = useNavigate();

    return (
        <Stack alignContent="center" alignItems="center" mt={4}>
            <Card sx={{ minWidth: "650px" }}>
                <CardContent>
                    <MprcFormSubHeader
                        title={training.name}
                        subtitle={training.multipleClasses ? classroom?.name : undefined}
                    />
                    {
                        ctx.result && ctx.result.totalSuccess != null && ctx.result.totalSuccess > 0 &&
                            <Box marginTop={3}>
                                <Typography variant="h4" color="success.main">{t("Enrollment.StepResult.SuccessSubtitle")}</Typography>
                                <Typography variant="body1" color="muted.main" marginLeft={4}>-&nbsp;
                                    <Trans
                                        i18nKey="Enrollment.StepResult.TotalSuccessMessage"
                                        values={{ count: ctx.result.totalSuccess }}
                                        components={AppTransComponents}
                                        t={t}
                                    />
                                </Typography>
                            </Box>
                    }
                    {
                        ctx.result && ctx.result.totalFail != null && ctx.result.totalFail > 0 &&
                            <Box marginTop={3}>
                               <Typography variant="h4" color="error.main">{t("Enrollment.StepResult.ErrorSubtitle")}</Typography>
                                <Stack direction="column">
                                    {ctx.result.usersFail?.map(item => (
                                        <Typography variant="body1" color="muted.main" component="span">-&nbsp;<strong>{item.name}: </strong>{item.message}</Typography>
                                    ))
                                }
                                </Stack>
                            </Box>
                    }
                </CardContent>
                <MprcCardActions>
                    <MprcButton
                        text={t("Enrollment.StepResult.StartPageButtonText")}
                        title={t("Enrollment.StepResult.StartPageButtonTitle")}
                        variant="contained"
                        color="muted"
                        onClick={() => navigate(LmsPaths.Home)}
                    />
                    <MprcButton
                        text={t("Enrollment.StepResult.NewOperationButtonText")}
                        title={t("Enrollment.StepResult.NewOperationButtonTitle")}
                        variant="contained"
                        color="primary"
                        onClick={() => props.goFirstStep()}
                    />
                </MprcCardActions>
            </Card>
        </Stack>
    );
};
